import { useReducer, createContext } from 'react'

export const IdentityVerificationContext = createContext()

function setSession(state, payload) {
	return {
		...payload,
	}
}

const reducer = (state, action) => {
	switch (action.type) {
	case 'SET_SESSION':
		return setSession(state, action.payload)
	default:
		return state
	}
}

export const IdentityVerificationContextProvider = (props) => {
	const [state, dispatch] = useReducer(reducer, {})

	return (
		<IdentityVerificationContext.Provider value={[state, dispatch]}>
			{props.children}
		</IdentityVerificationContext.Provider>
	)
}
